import dayjs, { UnitType } from 'dayjs';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isToday);

type Props = {
  type: UnitType;
  interval: number;
};

const makeTimeOptions = ({ type, interval }: Props) => {
  let target = dayjs().startOf('date');
  const results = [];

  while (target.isToday()) {
    const value = target.format('HH:mm');
    results.push({
      value,
      content: value,
    });
    target = target.add(interval, type);
  }

  return results;
};
export const HourOptions = makeTimeOptions({ type: 'hour', interval: 1 });
export const HalfHourOptions = makeTimeOptions({ type: 'hour', interval: 0.5 });

export default HourOptions;

export const requiredMinutesOptions = [0, ...Array(105 / 15)].map((_, i) => {
  return {
    value: `${(i + 1) * 15}`,
    content: `${(i + 1) * 15}分後`,
  };
});
